import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ShieldX, ArrowLeft, Home } from 'lucide-react'

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
      <div className="max-w-md w-full bg-card text-card-foreground rounded-lg border shadow-sm p-8 text-center">
        <ShieldX className="h-16 w-16 text-red-500 mx-auto" />
        <h1 className="mt-6 text-3xl font-bold text-foreground">403</h1>
        <h2 className="mt-2 text-xl font-semibold text-muted-foreground">Access Forbidden</h2>
        <p className="mt-4 text-muted-foreground">
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="outline" asChild>
            <Link to="/dashboard">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Link>
          </Button>
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Home
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
